// extracted by mini-css-extract-plugin
export default {"title":"YIZIMl4sgd","button":"_1PfSL3hH0I"};